import React from "react";
import {FormGroup} from "@unibuddy/patron";
import * as yup from "yup";
import {useTranslation} from "@unibuddy/intl";

import ReactSelect from "shared/Experimental/Forms/components/ReactSelect/ReactSelect";
import useAuth from "shared/Auth/hooks/useAuth";

import {Locale, Maybe} from "../../../../../types/generated";
import {IntlNamespaces} from "../../../../../translations/types";
import {INTL_LOCALE_PREFERENCE, INTL_SELECT_LANGUAGE} from "../../../../../translations/signup";
import {INTL_LANGUAGE_PREFERENCE_REQUIRED} from "../../../../../translations/validations";

export function LocalePreferenceFormField({
    applicableLocales,
}: {
    applicableLocales: Array<Maybe<Locale>>;
}) {
    const {authState} = useAuth();
    const {t} = useTranslation([IntlNamespaces.VALIDATIONS, IntlNamespaces.SIGNUP, "languages"]);
    const applicantLocalePreference = authState?.me?.applicant?.localePreference;

    const appLocales = applicableLocales.filter((locale) => !!locale);

    if (applicantLocalePreference || appLocales.length === 0) return null;

    return (
        <FormGroup
            initialValue={null}
            validation={yup
                .object()
                .nullable()
                .required(
                    t(
                        `${IntlNamespaces.VALIDATIONS}:${INTL_LANGUAGE_PREFERENCE_REQUIRED.key}`,
                        INTL_LANGUAGE_PREFERENCE_REQUIRED.defaultValue,
                    ),
                )}
            id="localePreference"
            label={t(
                `${IntlNamespaces.SIGNUP}:${INTL_LOCALE_PREFERENCE.key}`,
                INTL_LOCALE_PREFERENCE.defaultValue,
            )}
        >
            <ReactSelect
                id="localePreference"
                name="localePreference"
                required
                aria-label={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_LANGUAGE.key}`,
                    INTL_SELECT_LANGUAGE.defaultValue,
                )}
                placeholder={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_LANGUAGE.key}`,
                    INTL_SELECT_LANGUAGE.defaultValue,
                )}
                filterLabel={t(
                    `${IntlNamespaces.SIGNUP}:${INTL_SELECT_LANGUAGE.key}`,
                    INTL_SELECT_LANGUAGE.defaultValue,
                )}
                noOptionsMessage={() => t("noOptionsMessage", "No options")}
                options={appLocales.map((locale: Locale) => ({
                    value: locale,
                    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-argument
                    label: t(`${locale.name}`, locale.name, {
                        ns: "languages",
                    }),
                }))}
            />
        </FormGroup>
    );
}
